import React, { useEffect, useMemo } from 'react'
import sharedClasses from './signup.module.css'
import classes from './SignIn.module.css'
import classNames from 'classnames'
import loginImage from '../../assets/images/Login.jpg'
import logo from '../../assets/images/new-logo.png'
import { ReactComponent as ArrowRight } from '../../assets/icons/arrow-right.svg'
import { ValidatedLoginInput } from '../../components/Form/Inputs/Inputs'
import { Button, ButtonIcon } from '../../components/Button/Button'
import { Link, Redirect } from 'react-router-dom'
import { login, sendResetLink, resetPassword } from '../../api/authApi'
import { Formik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'
import * as yup from 'yup'
import { getParentRoute } from '../../util/functions'
import { authSelectors, authActions } from '../../redux/authSlice'
import notification from '../../components/Notification/notification'

const resetPasswordSchema = yup.object({
    password: yup.string().required('Please input a new password'),
    confirmPassword: yup
        .string()
        .oneOf([yup.ref('password')], 'Passwords do not match')
        .required('Please input your new password again'),
})

function ResetPassword({ location, history }) {
    const dispatch = useDispatch()
    const hasError = useSelector(authSelectors.getHasErrorState)
    const errorMessage = useSelector(authSelectors.getErrorMessageState)
    const success = useSelector(authSelectors.getSuccessState)
    const [token, type] = useMemo(() => {
        const params = new URLSearchParams(location.search)
        return [params.get('token'), params.get('type')]
    }, [location.search])

    const path = getParentRoute(location.pathname)

    const submitForm = async ({ password }) => {
        const [dismiss] = await notification.loading({
            title: 'Submitting...',
        })
        await dispatch(
            resetPassword({
                password,
                token,
            })
        )
        dismiss()
    }

    useEffect(() => {
        if (hasError) {
            notification.failure({
                title: 'Something went wrong',
                description: errorMessage,
            })
        }
    }, [hasError, errorMessage])

    useEffect(() => {
        if (success) {
            notification.success({
                title: 'Success',
                description: 'Password reset successfully',
            })
            dispatch(authActions.resetState())
            if (type === 'individual') history.push('/app/auth/sign-in')
            else if (type === 'business') history.push('/app/business/sign-in')
        }
    }, [success, type, history, dispatch])

    if (!token) {
        return <Redirect to="/app/auth/forgot-password" />
    }

    return (
        <div className={classNames(sharedClasses.container, classes.container)}>
            <Formik
                initialValues={{
                    password: '',
                    confirmPassword: '',
                }}
                onSubmit={submitForm}
                validationSchema={resetPasswordSchema}
            >
                {({ handleSubmit }) => (
                    <div
                        className={classNames(sharedClasses.form, classes.form)}
                    >
                        <img
                            src={logo}
                            alt="SME Upturn"
                            className={sharedClasses.formLogo}
                            onClick={() => history.push('/')}
                        />
                        <h1 className={sharedClasses.formHeader}>
                            Reset Password
                        </h1>
                        <div className={sharedClasses.formInputs}>
                            <ValidatedLoginInput
                                className={classes.input}
                                type="password"
                                placeholder={'New Password'}
                                name={'password'}
                            />
                            <ValidatedLoginInput
                                className={classes.input}
                                type="password"
                                placeholder={'Confirm New Password'}
                                name={'confirmPassword'}
                            />
                        </div>
                        <Button
                            className={sharedClasses.formButton}
                            onClick={handleSubmit}
                        >
                            Reset Password
                            <ButtonIcon icon={<ArrowRight />} />
                        </Button>
                        <span
                            className={classNames(
                                sharedClasses.formSplitLine,
                                classes.formSplitLine
                            )}
                        />
                        <p className={sharedClasses.formSignInText}>
                            Back to{' '}
                            <Link
                                to={`${path}/sign-in`}
                                className={sharedClasses.formSignInTextOrange}
                            >
                                Login
                            </Link>
                        </p>
                    </div>
                )}
            </Formik>
            <img
                src={loginImage}
                alt=""
                className={sharedClasses.displayImage}
            />
        </div>
    )
}

export default ResetPassword
